import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LookupModel } from '@app/configuration/models/configuration.models';
import { StateService } from '@uirouter/core';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';
import { InterruptService } from '../../shared';
import { ClientCasesRepositoryService } from '../client-cases.repository';
import { CovidVaccineModel } from '../models/client-cases.models';

@Component({
   selector: 'am-client-case-covid-vaccine',
   templateUrl: 'covid-vaccine.component.html',
   styleUrls: ['covid-vaccine.component.scss']
})
export class ClientCaseCovidVaccineComponent implements OnInit {
   @Input() involvementId: string;
   @Input() sourceId: string;
   @Input() activityId: string;

   get questionsForm() { return this.form.get('questions') as UntypedFormArray; }

   form: UntypedFormGroup;
   date: moment.Moment;
   today: moment.Moment;
   maxDate: moment.Moment;
   submitting: boolean;
   statuses: LookupModel[];
   covidVaccine: CovidVaccineModel;

   constructor(
      private formBuilder: UntypedFormBuilder,
      private clientCasesService: ClientCasesRepositoryService,
      private interruptService: InterruptService,
      private stateService: StateService
   ) { }

   ngOnInit() {
      this.today = moment().startOf('day');
      this.maxDate = this.today;
      this.form = this.formBuilder.group({
         activityDate: this.today,
         pWDHelped: [undefined],
         description: [undefined, Validators.required],
         status: undefined
      });
      if (this.activityId) {
         this.getCovidVaccine();
      }
   }

   private getCovidVaccine() {
      this.clientCasesService.getCovidVaccine(this.activityId).subscribe(covidVaccine => {
         this.form.patchValue({
            activityDate: moment(covidVaccine.activityDate),
            pWDHelped: covidVaccine.pwdHelped,
            description: covidVaccine.description
         });
      });
   }

   cancel() {
      this.stateService.go('.^');
      this.interruptService.allowNavigation();
   }

   submit() {
      if (this.form.invalid) { return; }
      this.submitting = true;
      const formData = this.form.getRawValue();
      const data: CovidVaccineModel = {
         activityId: this.activityId,
         involvementId: this.involvementId,
         caseId: this.sourceId,
         activityDate: formData.activityDate,
         pWDHelped: formData.pWDHelped,
         description: formData.description
      };

      const observable = this.activityId
      ? this.clientCasesService.updateCovidVaccine(data)
      : this.clientCasesService.createCovidVaccine(data);

      observable
      .pipe(finalize(() => this.submitting = false))
      .subscribe(result => {
         if (result) {
            this.submitting = false;
            this.interruptService.allowNavigation();
            this.stateService.go('.^');
         }
      });
   }
}